import { Service } from '@/types'
import { ActionIcon, Group, Text } from '@mantine/core'
import { IconChevronDown, IconChevronUp, IconX } from '@tabler/icons-react'

export default function ServicePill({
  service,
  onRemove,
  onEdit,
  onMoveUp,
  onMoveDown,
  readOnly = false,
  canRemove,
}: {
  service: Service
  onRemove: (id: number) => void
  onEdit: (service: Service) => void
  onMoveUp?: (id: number) => void
  onMoveDown?: (id: number) => void
  readOnly?: boolean
  canRemove: boolean
}) {
  const label = [
    service.service_name,
    service.instructions && `(${service.instructions})`,
    `${Number(service.price).toFixed(2)}€`,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Group
      gap={4}
      bg="gray.1"
      px={12}
      py={2}
      wrap="wrap"
      style={{
        borderRadius: 16,
        maxWidth: '100%',
      }}
    >
      <Text
        size="sm"
        fw={400}
        c="black"
        style={readOnly ? undefined : { cursor: 'pointer' }}
        onClick={readOnly ? undefined : () => onEdit(service)}
      >
        {label}
      </Text>
      {!readOnly && onMoveUp && (
        <ActionIcon variant="subtle" color="gray" size="sm" onClick={() => onMoveUp(service.id)}>
          <IconChevronUp size={14} />
        </ActionIcon>
      )}
      {!readOnly && onMoveDown && (
        <ActionIcon variant="subtle" color="gray" size="sm" onClick={() => onMoveDown(service.id)}>
          <IconChevronDown size={14} />
        </ActionIcon>
      )}
      {canRemove && (
        <ActionIcon variant="subtle" color="gray" size="sm" onClick={() => onRemove(service.id)}>
          <IconX size={14} />
        </ActionIcon>
      )}
    </Group>
  )
}
